﻿<template>
    <login_screen screen="login"></login_screen>
</template>

<script lang="ts" src="./login.ts"></script>